export const cognitoConfig = {
  UserPoolId: "ap-northeast-1_0TvWRBZPp",
  ClientId: "6e06o0d1gjb8ue8lh7ov7vojdj",
}